import { PorangeButton } from "../atoms/PorangeButton";
import { Inter } from "next/font/google";
import { SocialProofAvatars } from "../molecules/SocialProofAvatars";
import { getNoise } from "@/utils/noise";
import { MIN_SOCIAL_PROOF, MAX_SOCIAL_PROOF } from "@/constants/noise";
import { derivePossessiveForm } from "@/utils";
import { trackTopTenStartQuizClick } from "@/utils/mixpanel";
import { useEffect } from "react";
import config from "@/config";

const interFont = Inter({ subsets: ["latin"] });

const OriginalFixedGlutenFreeCTA = ({
    branchLink,
    area,
    placesCount,
    ctaTargetTestVariation,
    quizFlowControllerTestVariation,
}) => {
    return (
        <PorangeButton
            animate
            variation="large"
            disabled={ctaTargetTestVariation === 'direct_to_app' && !branchLink}
            onClick={(event) => {
                const buttonCta = event.target.textContent;
                trackTopTenStartQuizClick({
                    count: placesCount,
                    buttonCta,
                    isMobile: false,
                })


                if (ctaTargetTestVariation === 'direct_to_app') {
                    window.open(branchLink, "_blank");
                } else {
                    localStorage.setItem("gfe-short-quiz-area", area);
                    const domain = process.env.NEXT_PUBLIC_STAGE
                        ? config.top_ten_domain.replace("www", "web")
                        : // : window.location.origin;
                        "https://develop.d3ihunapjl2c3y.amplifyapp.com";

                    const searchParams = new URLSearchParams(window.location.search);
                    searchParams.set("lps", "tt");

                    let path = quizFlowControllerTestVariation === "short" ? "gfe-short-checkout" : "gfe-checkout";

                    window.open(
                        `${domain}/${path}/start?${searchParams.toString()}`,
                        "_blank"
                    );
                }
            }}
        >
            {derivePossessiveForm(area).toUpperCase()} FULL LIST
        </PorangeButton>
    )
}

export const OriginalFixedGlutenFreeFooter = ({
    branchLink,
    area,
    placesCount,
    ctaTargetTestVariation,
    quizFlowControllerTestVariation,
    isMobile,
}) => {
    const noise = getNoise("glutenfreeq", {
        min: MIN_SOCIAL_PROOF,
        max: MAX_SOCIAL_PROOF,
        range: MAX_SOCIAL_PROOF - MIN_SOCIAL_PROOF,
    });

    if (isMobile) {
        return (
            <section className="flex flex-col items-center justify-center fixed bottom-4 w-full">
                <OriginalFixedGlutenFreeCTA
                    branchLink={branchLink}
                    area={area}
                    placesCount={placesCount}
                    ctaTargetTestVariation={ctaTargetTestVariation}
                    quizFlowControllerTestVariation={quizFlowControllerTestVariation}
                />
            </section>
        )
    }
    return (
        <section
            id="gfe-footer-drawer"
            className={`${interFont.className} text-lg p-4 box-border text-blue-900 font-bold fixed bottom-0 w-full h-24 bg-neutral-100 border-t border-gray-200 z-50 flex items-center justify-between`}>
            <h1 className="text-xl">Discover all {derivePossessiveForm(area)} gluten-free spots</h1>
            <div className="flex items-center gap-4">
                <div className="flex items-center gap-2">
                    <SocialProofAvatars count={5} avatarsBorderColor="white" />
                    {noise.value} new GF spots found today 👉
                </div>
                <OriginalFixedGlutenFreeCTA
                    branchLink={branchLink}
                    area={area}
                    placesCount={placesCount}
                    ctaTargetTestVariation={ctaTargetTestVariation}
                    quizFlowControllerTestVariation={quizFlowControllerTestVariation}
                />
            </div>
        </section>
    )
};
